import { graphql, useStaticQuery } from 'gatsby';
import React, { FC, useContext } from 'react';
import { useDeepCompareEffect } from 'react-use';

import { keysToCamel } from '@utils/butter';
import { doesNotExist, exists } from '@utils/general';

import FlowContext from '@providers/FlowContextProvider';

import { IFlowStepProps } from '@folx-types/flow-steps';

import { medicationDeliveryConstants } from '../MedicationDeliveryStep';
import DeliveryConfirmationStep, {
	IDeliveryConfirmationStepPageContent,
} from './DeliveryConfirmationStep.component';

interface IDeliveryConfirmationStepPageProps extends IFlowStepProps {}

const DeliveryConfirmationStepPage: FC<IDeliveryConfirmationStepPageProps> = ({
	path,
	stepKey,
	...props
}) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "delivery-confirmation-step" }) {
				page_header
				pharmacy_top_text
				folx_description
				capsule_description
				edit_label
				expect_header
				pharmacy_expectation
				folx_expectation
				capsule_expectation
				testosterone_disclaimer
			}
		}
	`);

	const { existingFormData, handleNavNext, handleNavBack, flowId } = useContext(FlowContext);

	useDeepCompareEffect(() => {
		if (doesNotExist(existingFormData)) {
			return;
		}

		if (exists(existingFormData?.[medicationDeliveryConstants.MEDICATION_DELIVERY_METHOD])) {
			return;
		}

		props?.location?.state?.reverse ? handleNavBack(stepKey) : handleNavNext(stepKey);
	}, [existingFormData]);

	const refinedContent: IDeliveryConfirmationStepPageContent = keysToCamel(
		pageContent
	) as IDeliveryConfirmationStepPageContent;

	return (
		<DeliveryConfirmationStep
			pageContent={refinedContent}
			path={path}
			stepKey={stepKey}
			existingFormData={existingFormData}
			destinationFlow={flowId}
			handleNavNext={() => handleNavNext(stepKey)}
			handleNavBack={() => handleNavBack(stepKey)}
		/>
	);
};

export default DeliveryConfirmationStepPage;
